import { DiscountType } from '@repo/common';
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
    Separator,
    cn,
} from '@repo/shadcn';

import { PaymentStatusBadge } from '@components/ui/badge';

import { usePurchaseDetailsContext } from '@/modules/purchase/purchase-details/purchase-details.context';
import { formatCurrencyInBDT } from '@/utils';

// import { PaymentStatusBadge } from '@components/ui/badge';

export const PurchaseItems = () => {
    const { data } = usePurchaseDetailsContext();

    const subtotal =
        data?.data?.items?.reduce((acc: number, item: any) => {
            return acc + item.price * item.quantity;
        }, 0) || 0.0;
    const discount =
        data?.data?.discount_type === DiscountType.Fixed
            ? data?.data?.discount_value || 0.0
            : `${data?.data?.discount_value || 0.0}%`;
    const total = data?.data?.payment?.total_price || 0.0;
    const totalPaid = data?.data?.payment?.total_paid || 0.0;
    const totalDue = total - totalPaid;
    const orderStatus = data?.data?.payment?.status || '---';

    const renderItems = () => {
        if (!data || !data?.data?.items || data?.data?.items?.length === 0) {
            return (
                <div className={'flex items-center justify-center px-4 py-6'}>
                    No items found.
                </div>
            );
        }

        return data?.data?.items?.map((item: any) => {
            return (
                <div
                    key={item.id}
                    className="grid grid-cols-[repeat(14,1fr)] gap-4 text-sm"
                >
                    <div className="col-span-4 font-medium">
                        {item.product?.name}
                    </div>
                    <div className="col-span-2 text-right">
                        {formatCurrencyInBDT(item.purchase_price)}
                    </div>
                    <div className="col-span-2 text-right">
                        {formatCurrencyInBDT(item.wholesale_price)}
                    </div>
                    <div className="col-span-2 text-right">
                        {formatCurrencyInBDT(item.retail_price)}
                    </div>
                    <div className="col-span-2 text-right">{item.quantity}</div>
                    <div className="col-span-2 text-right font-medium">
                        {formatCurrencyInBDT(
                            item.purchase_price * item.quantity,
                        )}
                    </div>
                </div>
            );
        });
    };
    return (
        <Card>
            <CardHeader>
                <CardTitle className={'text-lg'}>Items</CardTitle>
            </CardHeader>
            <CardContent className={'space-y-4'}>
                <div className="space-y-4">
                    <div className="grid grid-cols-[repeat(14,1fr)] gap-4 text-sm font-semibold text-muted-foreground">
                        <div className="col-span-4">Name</div>
                        <div className="col-span-2 text-right">
                            Purchase Price
                        </div>
                        <div className="col-span-2 text-right">
                            Wholesale Price
                        </div>
                        <div className="col-span-2 text-right">
                            Retail Price
                        </div>
                        <div className="col-span-2 text-right">Quantity</div>
                        <div className="col-span-2 text-right">Total</div>
                    </div>
                    <Separator />
                    {renderItems()}
                </div>

                <Separator />

                <Separator />

                {/* Summary Section */}
                <div className="space-y-3 text-sm">
                    <div className="flex justify-between">
                        <span className="text-muted-foreground">
                            Sub Total:
                        </span>
                        <span className="font-semibold">
                            {formatCurrencyInBDT(subtotal)}
                        </span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-muted-foreground">Discount:</span>
                        <span className="font-semibold">{discount}</span>
                    </div>
                    <div className="flex justify-between border-t pt-3">
                        <span className="font-semibold">Total:</span>
                        <span className="text-lg font-bold">
                            {formatCurrencyInBDT(total)}
                        </span>
                    </div>
                </div>

                <Separator />

                {/* Payment Details */}
                <div className="space-y-3 text-sm">
                    <div className="flex justify-between">
                        <span className="text-muted-foreground">
                            Total Paid:
                        </span>
                        <span className="font-medium">
                            {formatCurrencyInBDT(totalPaid)}
                        </span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-muted-foreground">
                            Total Due:
                        </span>
                        <span
                            className={cn('font-medium', {
                                'text-red-600': totalDue > 0,
                                '': totalDue <= 0,
                            })}
                        >
                            {formatCurrencyInBDT(totalDue)}
                        </span>
                    </div>
                    <div className="flex justify-between border-t pt-3">
                        <span className="font-semibold">Payment Status:</span>
                        <PaymentStatusBadge status={orderStatus} />
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

PurchaseItems.displayName = 'PurchaseItems';
